/**
 * R49 / T6 — prefetch fallback for engines without Speculation Rules.
 *
 * Chromium reads the <script type="speculationrules"> block in snippets/eh-instant-nav.liquid
 * and prerenders on hover. Safari and Firefox ignore it, so this warms the HTTP cache with
 * <link rel="prefetch"> on the same signals. A prefetch is a smaller win than a prerender —
 * it saves the round trip, not the render — but it is the honest fallback.
 *
 * It exits immediately where speculation rules are supported, so the two never both run.
 *
 * The exclusion list is kept identical to the Liquid one on purpose. If one changes, both
 * change: a URL that is unsafe to prerender is unsafe to prefetch.
 */
(function () {
  'use strict';

  if (window.HTMLScriptElement && typeof HTMLScriptElement.supports === 'function' && HTMLScriptElement.supports('speculationrules')) {
    return;
  }

  // Never spend a shopper's data allowance on a guess.
  var conn = navigator.connection;
  if (conn && (conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var EXCLUDED = /^\/(cart|checkout|account|orders|apps|tools|services)(\/|$|\?)|logout/i;
  var MAX = 12;
  var seen = new Set();
  var head = document.head || document.documentElement;

  function candidate(a) {
    if (!a || !a.href || seen.size >= MAX) return null;
    if (a.target && a.target !== '_self') return null;
    if (a.hasAttribute('download')) return null;
    if (a.closest('[data-no-instant]')) return null;

    var url;
    try { url = new URL(a.href, location.href); } catch (e) { return null; }
    if (url.origin !== location.origin) return null;
    if (url.pathname === location.pathname && url.search === location.search) return null;
    if (EXCLUDED.test(url.pathname)) return null;

    var key = url.pathname + url.search;
    if (seen.has(key)) return null;
    return { url: url, key: key };
  }

  function prefetch(event) {
    var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    var hit = candidate(a);
    if (!hit) return;
    seen.add(hit.key);

    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = hit.url.href;
    link.as = 'document';
    head.appendChild(link);
  }

  // pointerenter does not bubble, so hover is caught with pointerover; touch and keyboard
  // users get the same head start from their own first signal.
  document.addEventListener('pointerover', prefetch, { capture: true, passive: true });
  document.addEventListener('pointerdown', prefetch, { capture: true, passive: true });
  document.addEventListener('focusin', prefetch, { capture: true, passive: true });
  document.addEventListener('touchstart', prefetch, { capture: true, passive: true });
})();
